module.exports = __webpack_public_path__ + "static/media/people-photo-product.b53fa5f4.jpg";